import { useEffect } from "react";
import { track } from "@/lib/tracking";

/**
 * Dispara `scroll_75` uma vez por page-view quando o usuário atinge 75%
 * de profundidade na página. Reset no path change não é necessário porque
 * page_view já é disparado por route change.
 */
export function useScrollDepth() {
  useEffect(() => {
    let fired = false;
    const handler = () => {
      if (fired) return;
      const scrollY = window.scrollY;
      const viewport = window.innerHeight;
      const total = document.documentElement.scrollHeight;
      const max = total - viewport;
      if (max <= 0) return;
      const pct = scrollY / max;
      if (pct >= 0.75) {
        fired = true;
        track("scroll_75", { path: window.location.pathname });
        window.removeEventListener("scroll", handler);
      }
    };

    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);
}
